import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CouponComponent} from '../views/pages/coupon/coupon.component';
import {CouponCreateComponent} from '../views/pages/coupon/create/coupon-create.component';
import {CouponEditComponent} from '../views/pages/coupon/edit/coupon-edit.component';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTableModule} from '@angular/material/table';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FlexModule} from '@angular/flex-layout';



@NgModule({
  declarations: [
    CouponComponent,
    CouponCreateComponent,
    CouponEditComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTableModule,
    FlexModule,
  ],
  exports: [
    CouponComponent,
    CouponCreateComponent,
    CouponEditComponent,
  ]
})
export class SharedModule { }
